export default __webpack_public_path__ + "static/media/jenkins.b303c728.svg";